import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActiveProductOfferingsPipe } from './active-product-offerings.pipe';

@NgModule({
  declarations: [ActiveProductOfferingsPipe],
  exports: [ActiveProductOfferingsPipe],
  imports: [CommonModule],
})
export class ActiveProductOfferingsModule {}
